<template>
<div id="trafico-embarque-detalle">

    <div v-for="(detalle, index) in detalles" v-bind:key="index">

        <v-row style="flex-wrap: nowrap;">
            <v-col cols="3" class="flex-grow-0 flex-shrink-0">
                <v-select v-model="detalle.tipo" label="Tipo" :items="tipos" :clearable="false" :rules="[rules.required]" item-value="id" item-text="nombre" @input="limpiar(index)"></v-select>

            </v-col>
            <v-col cols="3" class="flex-grow-1 flex-shrink-0">
                <v-autocomplete v-model="detalle.embarcador" :items="consignatarios" :hide-no-data="true" item-text="metadato" item-value="metadato" label="Selecciona un Embarcador/Consignatario" :rules="[rules.required]" @input="setConsignatario(detalle.embarcador, index)" v-if="detalle.tipo==2"></v-autocomplete>

                <v-autocomplete v-model="detalle.emisor" :items="emisores" :hide-no-data="true" item-text="metadato" item-value="metadato" label="Selecciona un Emisor/Destinatario" :rules="[rules.required]" @input="setEmisor(detalle.emisor, index)" v-if="detalle.tipo==1"></v-autocomplete>

            </v-col>
            <v-col cols="3" class="flex-grow-0 flex-shrink-1">

                <v-text-field :name="'rfc_tax_id['+padre+']['+index+']'" label="RFC o TAX ID" type="text" autocomplete="off" v-model="detalle.rfc_tax_id" :rules="[rules.required]" maxlength="30"></v-text-field>

            </v-col>
            <v-col cols="3" class="flex-grow-0 flex-shrink-1">
                <v-text-field :name="'pais_procedencia_destino['+padre+']['+index+']'" label="País de Procedencia / Destino" type="text" autocomplete="off" v-model="detalle.pais_procedencia_destino" maxlength="30"></v-text-field>

            </v-col>
        </v-row>
        <v-row style="flex-wrap: nowrap;">
            <v-col cols="3" class="flex-grow-0 flex-shrink-0">
                <v-autocomplete v-model="detalle.consignatario1" :items="consignatarios" :hide-no-data="true" item-text="metadato" item-value="metadato" label="Consignatario 1"></v-autocomplete>

            </v-col>
            <v-col cols="3" class="flex-grow-1 flex-shrink-0">
                <v-autocomplete v-model="detalle.consignatario2" :items="consignatarios" :hide-no-data="true" item-text="metadato" item-value="metadato" label="Consignatario 2"></v-autocomplete>

            </v-col>
            <v-col cols="3" class="flex-grow-0 flex-shrink-1">

                <v-autocomplete v-model="detalle.consignatario3" :items="consignatarios" :hide-no-data="true" item-text="metadato" item-value="metadato" label="Consignatario 3"></v-autocomplete>

            </v-col>
            <v-col cols="3" class="flex-grow-0 flex-shrink-1">
                <v-text-field :name="'Otro['+padre+']['+index+']'" label="Otro" type="text" autocomplete="off" v-model="detalle.otro" maxlength="30"></v-text-field>

            </v-col>
        </v-row>
    </div>

    <p />

</div>
</template>

<script>
import Vue from "vue";
import axios from "axios";

export default {

    created: function () {

        this.cargarEmisores();
        this.cargarConsignatarios();

        if (this.$store.state.embarques_trafico[this.padre].especificaciones.length > 0) {
            this.$store.state.embarques_trafico[this.padre].especificaciones.forEach(element => {

                if (element.emisor.length > 0)
                    element.tipo = 1;

                this.detalles.push(Vue.util.extend({}, element));
            });
        } else
            this.addNew();

        this.$watch('detalles', this.formChanged, {
            deep: true
        });
    },
    beforeDestroy: function () {
        this.detalles = [];
    },

    methods: {
        addNew: function () {
            this.detalles.push(Vue.util.extend({}, this.detalle));
            this.$store.state.embarques_trafico[this.padre].especificaciones = this.detalles;

        },
        remove: function (index) {
            Vue.delete(this.detalles, index);
            this.$store.state.embarques_trafico[this.padre].especificaciones = this.detalles;

        },
        setEmisor: function (emisor, indice) {
            var emisores = this.emisores.filter(function (emi) {
                return emi.metadato == emisor;
            });
            this.detalles[indice]['rfc_tax_id'] = emisores[0].rfc;
            this.detalles[indice]['pais_procedencia_destino'] = emisores[0].pais.clave_m3 != null ? emisores[0].pais.clave_m3 : emisores[0].pais.nombre;
        },
        limpiar: function (indice) {
            this.detalles[indice]['embarcador'] = "";
            this.detalles[indice]['emisor'] = "";
            this.detalles[indice]['rfc_tax_id'] = "";
            this.detalles[indice]['pais_procedencia_destino'] = "";
        },
        setConsignatario: function (consignatario, indice) {
            var consignatarios = this.consignatarios.filter(function (emi) {
                return emi.metadato == consignatario;
            });
            this.detalles[indice]['rfc_tax_id'] = consignatarios[0].rfc;
            this.detalles[indice]['pais_procedencia_destino'] = consignatarios[0].pais.clave_m3 != null ? consignatarios[0].pais.clave_m3 : consignatarios[0].pais.nombre;
        },
        cargarEmisores: function () {
            var cliente_id = this.$local_storage.get("id_cliente");
            if (cliente_id > 0) {
                var datos = {
                    cliente: cliente_id,
                };
                axios.post(this.$hostname + 'catalogos/emisores_destinatarios/get_emisores/', datos)
                    .then((res) => {
                        if (typeof res.data !== 'undefined') {
                            this.emisores = res.data;
                        }
                    })
                    .catch((err) => {
                        this.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "Error al obtener los emisores"
                        });
                        console.log(err.response);
                    });
            }

        },
        cargarConsignatarios: function () {
            var cliente_id = this.$local_storage.get("id_cliente");
            if (cliente_id > 0) {
                var datos = {
                    cliente: cliente_id,
                };
                axios.post(this.$hostname + 'catalogos/embarcadores_consignatarios/get_embarcadores_consignatarios/', datos)
                    .then((res) => {
                        if (typeof res.data !== 'undefined') {
                            this.consignatarios = res.data;
                        }
                    })
                    .catch((err) => {
                        this.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "Error al obtener los Embarcadores"
                        });

                        console.log(err.response);
                    });
            }

        },
        formChanged: function (newV, oldV) {
            this.$store.state.embarques_trafico[this.padre].especificaciones = this.detalles;
            this.$root.$emit("formDetalleChanged", newV);
        }
    },
    props: {
        padre: {
            type: Number,
            default: 0
        },
    },
    data: () => ({
        fab: false,
        tipos: [{
            'id': 1,
            'nombre': 'Emisor - Destinatario'
        }, {
            'id': 2,
            'nombre': 'Embarcador - Consignatario '
        }],
        emisores: [],
        consignatarios: [],
        formUpdated: false,
        detalle: {
            tipo: 1,
            emisor: "",
            embarcador: "", //*Tipo String Opcional*
            rfc_tax_id: "", //*Tipo String Opcional*
            pais_procedencia_destino: "", //*Tipo String Opcional*
            consignatario1: "", //*Tipo String Opcional*
            consignatario2: "", //*Tipo String Opcional*
            consignatario3: "", //*Tipo String Opcional*
            otro: "" //*Tipo String Opcional*
        },
        detalles: [],
        rules: {
            required: v => !!v || "Este campo es requerido"
        },

    })
};
</script>
